<div class="fixed top-4 right-4 z-[9999] animate-[slideInUp_0.4s_ease] w-80 max-w-[calc(100vw-2rem)]">
  <div class="flex items-center gap-3 bg-gradient-to-r from-info to-info-dark text-white rounded-lg shadow-md p-3 border border-info-dark/20 backdrop-blur-sm">
    <!-- Icon -->
    <div class="flex-shrink-0 w-8 h-8 bg-white/20 rounded-full flex items-center justify-center">
      <svg class="w-5 h-5" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 16V12M12 8H12.01M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>
    
    <!-- Message -->
    <div class="flex-1">
      <p class="text-xs font-normal leading-relaxed">{{ message() }}</p>
    </div>
    
    <!-- Close Button -->
    <button 
      (click)="closeToast()" 
      aria-label="Close notification"
      class="flex-shrink-0 w-7 h-7 bg-white/20 rounded-full flex items-center justify-center hover:bg-white/30 transition-colors"
    >
      <svg class="w-4 h-4" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15 5L5 15M5 5L15 15" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </button>
  </div>
</div>
